import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/pro-solid-svg-icons'
import TreeView from 'components/ui/CourseLessonsTreeView/TreeView'
import * as fromActions from 'store/actions/courses.action'
import { IMainState } from 'store/states'
import Loader from 'components/ui/loader/Loader'
import Button, {
  ButtonSizes,
  ButtonVariant,
} from 'design-system/button/src/Button'
import styles from './DuplicateCourseModal.module.scss'

interface IDuplicateCourseModal {
  show: number
  onClose: any
}

const DuplicateCourseModal: React.FC<IDuplicateCourseModal> = ({
  show,
  onClose,
}) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { courseToDuplicate, loadingCoursesToDuplicate } = useSelector(
    ({ courses }: IMainState) => courses
  )
  const [courseData, setCourseData] = useState({} as any)
  const [lessonData, setlessonData] = useState([] as any)
  const [selected, setSelected] = useState({} as any)
  const [canSubmit, setCanSubmit] = useState(true)

  useEffect(() => {
    show > 0 &&
      dispatch({
        type: fromActions.GET_COURSE_DATA_TO_DUPLICATE,
        payload: show,
      })
  }, [dispatch, show])

  const handleSubmit = () => {
    selected.id &&
      dispatch({ type: fromActions.COURSE_DUPLICATE, payload: selected })
    onClose()
  }

  useEffect(() => {
    if (courseToDuplicate.id) {
      setlessonData(courseToDuplicate.lessons)
      setCourseData(courseToDuplicate)
    }
  }, [courseToDuplicate])

  const handleSetSelected = (data: any) => {
    const result = { id: show, lessons: [] } as any
    data.map((lesson: any) => {
      let aux = {} as any
      if (lesson.checked || lesson.blocks.length > 0) {
        aux = { id: lesson.lessonId, blocks: [] }
        lesson.blocks.map((block: number) => {
          aux.blocks.push({ id: block })
        })
        result.lessons.push(aux)
      }
    })
    setSelected(result.lessons.length > 0 ? result : {})
    setCanSubmit(result.lessons.length > 0)
  }

  return (
    <>
      <Modal
        show={show > 0}
        centered
        onHide={onClose}
        className={styles.modalContainer}
      >
        <Modal.Header closeButton className={`p-0 pb-2`}>
          <Modal.Title className={styles.modalTitle}>
            {t('administration.courses.duplicate.duplicateCourse')}{' '}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={`p-0 pt-3 ${styles.modalBody}`}>
          {loadingCoursesToDuplicate ? (
            <Loader color />
          ) : (
            <>
              <div className={styles.instruction}>
                {t('administration.courses.duplicate.selectElementsOf')}{' '}
                <b> {courseData.name}</b>{' '}
                {t('administration.courses.duplicate.toDuplicate')}:
              </div>
              <TreeView data={lessonData} onChange={handleSetSelected} />
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0 pr-0">
          <Button
            disabled={!canSubmit}
            size={ButtonSizes.Small}
            variant={ButtonVariant.Primary}
            className="m-0"
            onClick={handleSubmit}
          >
            <FontAwesomeIcon icon={faCopy} className="mr-2" />
            {t('administration.courses.duplicate.buttons.duplicate')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default DuplicateCourseModal
